export default "https://studio-ui-deployments.apollographql.com/build/static/assets/favicon.c44bb98fc901909f5d6d479b5b024aa5.png";